import { ref } from 'vue'

export const currentCurrency = ref(localStorage.getItem('currency') || 'PLN')

export function setCurrency(cur) {
  currentCurrency.value = cur
  localStorage.setItem('currency', cur)
  // Możesz tutaj wywołać reload danych lub event refetch np. eventBus.emit('currencyChanged')
}